






<ng-container *ngIf="results | async as _results; else loading">
  <ng-container *ngTemplateOutlet="resultsTemplate;context:{results:_results}"></ng-container>
</ng-container>


<ng-template #loading>

  <ng-container *ngIf="loadingTemplate == null else loadingTemplates">
    loading.....
  </ng-container>

  <ng-template #loadingTemplates>
    <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
  </ng-template>

</ng-template>
